module.exports = __webpack_public_path__ + "img/zhaob.f7d089c9.png";